import { Api, ApiRequest, ResType } from '@api'
import { Logger } from '@utils'
import {
	GetOrderCustomerReqType,
	GetOrderDetailReqType,
	OrderCreationType,
	OrderDeletionType,
	OrderUpdatePathType,
	OrderUpdateType,
} from '@schemas'

export const getOrder = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/order'
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const addOrder = async ({
	body = {
		seasonId: '',
		customerId: '',
		couponId: '',
		receiverName: '',
		phoneCountryNumber: '',
		phoneNumber: '',
		address1: '',
		address2: '',
		city: '',
		state: '',
		zip: '',
		country: '',
	} as OrderCreationType,
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/order'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const deleteOrder = async ({
	params = { orderId: '' } as OrderDeletionType,
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/order/${params.orderId}`
		const req = new ApiRequest({
			method: 'delete',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const updateOrder = async ({
	params = { orderId: '' } as OrderUpdatePathType,
	body = {
		deliveryCompany: '',
		trackingNumber: '',
		deliveryCompletedAt: '',
	} as OrderUpdateType,
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/order/${params.orderId}`
		const req = new ApiRequest({
			method: 'put',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const getOrderCustomer = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/order/customer'
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const getOrderDetail = async ({
	query = {
		orderId: '',
	} as GetOrderDetailReqType,
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/order/detail'
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

const orderApi = {
	getOrder: getOrder,
	addOrder: addOrder,
	deleteOrder: deleteOrder,
	updateOrder: updateOrder,
	getOrderCustomer: getOrderCustomer,
	getOrderDetail: getOrderDetail,
}

export default orderApi
